import { render, staticRenderFns } from "./LoaderAppie.vue?vue&type=template&id=4c397952"
import script from "./LoaderAppie.vue?vue&type=script&lang=js"
export * from "./LoaderAppie.vue?vue&type=script&lang=js"
import style0 from "./LoaderAppie.vue?vue&type=style&index=0&id=4c397952&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports